import React from 'react';
import * as Sentry from '@sentry/react';
import { environments } from './utils/enums';
import { Route } from 'react-router-dom';
import { Switch } from 'react-router';
import { createBrowserHistory } from 'history';
import { Auth } from 'aws-amplify';
import './index';
import { pathname } from './utils';
import LinesContextProvider from './contexts/Lines';
import { Integrations } from '@sentry/tracing';
import './themes/BRK/fonts/Muli-Black.ttf';
import './themes/BRK/fonts/Muli-Light.ttf';
import './themes/BRK/fonts/Muli-Regular.ttf';
import './themes/BRK/fonts/Muli-Bold.ttf';
import Login from './pages/auth/login';
import Forgot from './pages/auth/forgot';
import ResetPassword from './pages/auth/resetPassword';
import ChangePassword from './pages/auth/changePassword';
import ChangePasswordSignedIn from './components/auth/ChangePasswordSignedIn';
import Account from './pages/account/account';
import EditCompany from './pages/account/editBusiness';
import EditUsername from './pages/account/editName';
import BankOAuth from './pages/account/bankOAuth';
import AmazonSellerRedirect from './pages/amazonSellerRedirect';
import WiseRedirect from './pages/wiseRedirect';
import Dashboard from './pages/dashboard';
import Lines from './pages/lines';
import Plans from './pages/plans';
import SubmitApplication from './pages/submitApplication';
import PaymentsTwo from './pages/paymentsTwo';
import Footer from './components/Footer/Footer';
import Content from './components/Content';
import Body from './components/Body';
import WithSidebar from './components/Sidebar/WithSidebar';
import ShopifyAuthRedirect from './pages/shopifyAuthRedirect';
import ShopifyAppInstall from './pages/shopifyAppInstall';
import Welcome from './pages/buildYourGrowthPlanUrl/welcome';
import QobPlatform from './pages/onboarding/getStarted/platform/platform-type';
import QobSalesRevenue from './pages/onboarding/getStarted/revenue';
import QobAccountCreation from './pages/onboarding/getStarted/signup';
import Calculator from './pages/calculator';
import ConnectAccounts from './pages/connectAccounts';
import SignupRoute from './Routes/SignupRoute';
import OnboardingRoutes from './Routes/Onboarding/OnboardingRoutes';
import LoadingPage from './pages/loading';

export default function App() {
  Auth.configure({
    region: 'us-west-2',
    userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scope: [
        'phone',
        'email',
        'profile',
        'openid',
        'aws.cognito.signin.user.admin',
      ],
      redirectSignIn: `${window.location.origin}/`,
      responseType: 'code',
    },
  });

  const env = process.env.REACT_APP_ENV;
  const isProd = env === environments.prod;

  const history = createBrowserHistory();

  if (isProd) {
    Sentry.init({
      dsn: 'https://218fcc47f7a1476aafe8958877e7b5e3@o684114.ingest.sentry.io/5771412',
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }),
      ],
      tracesSampleRate: 1.0,
    });
  }

  return (
    <>
      <LinesContextProvider>
        <Switch>
          <WithSidebar>
            <Content>
              <Body>
                <SignupRoute />
                <OnboardingRoutes />
                <Route
                  exact
                  path={pathname.dashboard.url}
                  component={Dashboard}
                />
                <Route exact path={pathname.lines.url} component={Lines} />
                <Route
                  exact
                  path={pathname.submitApplication.url}
                  component={SubmitApplication}
                />
                <Route
                  exact
                  path={pathname.remittance.url}
                  component={PaymentsTwo}
                />
                <Route exact path={pathname.plans.url} component={Plans} />
                <Route
                  exact
                  path={pathname.account.main.url}
                  component={Account}
                />
                <Route
                  exact
                  path={pathname.account.changePw.url}
                  component={ChangePasswordSignedIn}
                />
                <Route
                  exact
                  path={pathname.account.editCompany.url}
                  component={EditCompany}
                />
                <Route
                  exact
                  path={pathname.account.editUserName.url}
                  component={EditUsername}
                />
                <Route
                  exact
                  path={pathname.account.bankOAuth.url}
                  component={BankOAuth}
                />
                <Route
                  exact
                  path={pathname.amazonRedirect.url}
                  component={AmazonSellerRedirect}
                />
                <Route
                  exact
                  path={pathname.wiseRedirect.url}
                  component={WiseRedirect}
                />
                <Route
                  exact
                  path={pathname.preLogin.login.url}
                  component={Login}
                />
                <Route
                  exact
                  path={pathname.preLogin.forgotPw.url}
                  component={Forgot}
                />
                <Route
                  exact
                  path={pathname.preLogin.resetPw.url}
                  component={ResetPassword}
                />
                <Route
                  exact
                  path={pathname.preLogin.changePw.url}
                  component={ChangePassword}
                />
                <Route
                  exact
                  path={pathname.shopify.authRedirect.url}
                  component={ShopifyAuthRedirect}
                />
                <Route
                  exact
                  path={pathname.preLogin.getStarted.platform.url}
                  component={QobPlatform}
                />
                <Route
                  exact
                  path={pathname.preLogin.getStarted.salesRevenue.url}
                  component={QobSalesRevenue}
                />
                <Route
                  exact
                  path={pathname.preLogin.getStarted.accountCreation.url}
                  component={QobAccountCreation}
                />
                <Route
                  exact
                  path={pathname.BuildYourGrowthPlanUrl.welcome.url}
                  component={Welcome}
                />
                <Route
                  exact
                  path={pathname.preLogin.shopifyAppInstall.url}
                  component={ShopifyAppInstall}
                />
                <Route
                  exact
                  path={pathname.preLogin.calculator.url}
                  component={Calculator}
                />
                <Route
                  exact
                  path={pathname.connectAccounts.url}
                  component={ConnectAccounts}
                />
                <Route
                  exact
                  path={pathname.preLogin.loadingPage.url}
                  component={LoadingPage}
                />
              </Body>
              <Footer />
            </Content>
          </WithSidebar>
        </Switch>
      </LinesContextProvider>
    </>
  );
}
